// Central media-asset URL resolver.
//
// All static media (images, PDFs, videos) lives in an S3 bucket whose keys mirror the
// old frontend/public/ tree (e.g. /images/about_ncet.png -> key images/about_ncet.png).
// This helper maps every legacy asset reference onto that bucket so the apps load media
// from S3 instead of the local public folder or ncet.co.in.
//
// Backend-uploaded files (\uploads\..) are the ONE exception: they still resolve against
// the API host (REACT_APP_DATABASEURL), unchanged.

const ASSET_BASE = (
  process.env.REACT_APP_ASSET_BASE_URL ||
  "https://ncet-727596873106-ap-south-2-an.s3.ap-south-2.amazonaws.com"
).replace(/\/+$/, ""); // strip any trailing slash

const API_BASE = process.env.REACT_APP_DATABASEURL || "";

// Build an S3 URL from a bucket key (leading slashes stripped).
const onS3 = (key) => `${ASSET_BASE}/${String(key).replace(/^\/+/, "")}`;

// Resolve a stored/legacy asset path to a usable URL.
export const assetUrl = (input) => {
  if (!input) return "";
  const u = String(input).replace(/\\/g, "/"); // normalize Windows backslashes

  // 1) Legacy host -> rewrite onto S3 (same key tree).
  const legacy = u.match(/^https?:\/\/(?:www\.)?ncet\.co\.in\/(.+)$/i);
  if (legacy) return onS3(legacy[1]);

  // 2) Any other absolute URL (already S3 or external) -> use as-is.
  if (/^https?:\/\//i.test(u) || u.startsWith("//")) return u;

  // 2b) Non-asset references: anchors and non-http schemes (mailto:, tel:, data:, ...).
  if (u.startsWith("#") || /^[a-z][a-z0-9+.-]*:/i.test(u)) return u;

  // 3) Backend-uploaded files stay on the API host (UNCHANGED).
  if (u.startsWith("/uploads") || u.startsWith("uploads")) {
    return `${API_BASE}${u.replace(/^\//, "")}`;
  }

  // 4) Everything else is a public-folder asset mirrored into S3.
  return onS3(u);
};

// Samashti-style resolver: base path + filename, unless the file is a full URL, an
// uploaded file, or already an absolute key.
export const resolveAsset = (base, file) => {
  if (!file) return "";
  const f = String(file).replace(/\\/g, "/");
  if (/^https?:\/\//i.test(f) || f.includes("uploads") || f.startsWith("/")) {
    return assetUrl(f);
  }
  return assetUrl(`${base || ""}${f}`);
};

// Back-compat alias so existing `mediaUrl(...)` call sites keep working unchanged.
export const mediaUrl = assetUrl;

export default assetUrl;
